import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { resetStore, useAppDisPatch, useAppSelector } from '../../redux/store';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';
import useHttps from '../useHttps';

const useOnLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();
  const request = useHttps();
  const refreshToken = useAppSelector((state) => state.auth.authData?.refreshToken?.token);

  const logoutUser = () => {
    const finish = () => {
      toast.success('Signed Out');
      localStorage.removeItem('authData');
      dispatch(resetStore());
      navigate(`${ACCOUNT}/${SIGNIN}`);
    };

    if (refreshToken) {
      // Best-effort: revoke the refresh token server-side. The user is
      // logged out locally regardless of whether this call succeeds.
      request(
        {
          url: 'api/v1/auth/admin/logout',
          method: 'post',
          data: { refresh_token: refreshToken },
          skipLogoutRedirect: true,
        },
        finish,
        undefined,
        finish
      );
    } else {
      finish();
    }
  };

  return { logoutUser };
};

export default useOnLogout;
